import { MarkdownRenderer } from '../markdown-render/markdown-render';
import { Text } from '../text/text';
import { ArticleWrapper, TitleWrapper } from './article.styles';

interface ArticleProps {
  title: string;
  text: string;
  date: string | null;
  showDate: boolean;
}
export function Article({ title, text, date, showDate }: ArticleProps) {
  return (
    <ArticleWrapper>
      {showDate && (
        <Text $variant="articleparag" $color="primary-base100" $fontWeight="Light">
          {date}
        </Text>
      )}
      <TitleWrapper>
        <Text $variant="h5" $color="primary-base100">
          {title}
        </Text>
      </TitleWrapper>
      <MarkdownRenderer $variant="smallparag" markdown={text} forceWrapper={false} />
    </ArticleWrapper>
  );
}
